import React, { FC, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Button } from 'antd';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { Link } from 'react-router-dom';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import { BUYER_NOTIFICATION_APPROVALS_TYPES_MAP } from '../../utils/NotificationUtils';
import { userNotificationsRestCrudThunksForBuyer } from '../../thunks/user_notifications_thunks';
import OverviewShell from '../overview_shell/OverviewShell';

require('./BuyerNotificationsOverviewPage.less');

const BuyerNotificationsOverviewPage: FC<any> = ({
	fetchUserNotificationsCountForBuyer,
	currentUser,
	history,
	location,
	userNotifications,
	childRoutes,
}) => {
	useEffect(() => {
		if (currentUser) {
			fetchUserNotificationsCountForBuyer(
				{
					isActionRequired: true,
					pendingApproval: true,
					notificationTypes: BUYER_NOTIFICATION_APPROVALS_TYPES_MAP.map((filter) => {
						if (filter.children && filter.children.length > 0) {
							return filter.children.map((child) => child.key);
						}
						return filter.key;
					}).flat(),
				},
				'NotificationsApprovals'
			);
		}
	}, [currentUser, fetchUserNotificationsCountForBuyer]);

	const handleTabChange = useCallback(
		(key) => {
			history.push(`/buyer/inbox/overview/${key}`);
		},
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history]
	);

	const unreadCount = nullSafeGet('counts.TASKS_NOTIFICATIONS', userNotifications);
	const unreadWaitingonMeCount = nullSafeGet('counts.NotificationsApprovals', userNotifications);

	const tabs = [
		{
			key: 'important',
			name: unreadCount ? (
				<>
					Important <span className="text-base ">({unreadCount})</span>
				</>
			) : (
				'Important'
			),
		},
		{
			key: 'approvals',
			name: unreadWaitingonMeCount ? (
				<>
					Approvals <span className="text-base ">({unreadWaitingonMeCount})</span>
				</>
			) : (
				'Approvals'
			),
		},
		{
			key: 'notes',
			name: 'Notes',
		},
		{
			key: 'status',
			name: 'Status Updates',
		},
	];

	const settingsButton = (
		<div className="flex gap-x-4 ">
			<Link
				to={getLinkWIthBackLinkParams(location, 'Back to Inbox', `/buyer/settings/notifications`)}
				style={{ marginRight: 16 }}
			>
				<Button ghost={true}>Settings</Button>
			</Link>
		</div>
	);

	return (
		<>
			<Route
				path="/buyer/inbox/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/buyer/inbox/overview/important',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Inbox"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="buyerNotificationsPage"
				headerRightContent={settingsButton}
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	companyConfig: state.company_config,
	userNotifications: state.user_notifications,
	userType: state.session.userType,
});
const mapDispatchToProps = (dispatch) => ({
	fetchUserNotificationsCountForBuyer: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.countBy(params, countName)),
});
export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(BuyerNotificationsOverviewPage)
);
